import * as React from 'react';
import * as DialogPrimitive from '@radix-ui/react-dialog';
import { X } from 'lucide-react';
import { cva, VariantProps } from 'class-variance-authority';

import { cn } from '../../utils/cn';

const dialogCloseVariants = cva('rocco-dialog-close', {
    variants: {
        variant: {
            default:
                'absolute right-4 top-4 rounded-sm opacity-70 ring-offset-background transition-opacity hover:opacity-100 focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 disabled:pointer-events-none data-[state=open]:bg-accent data-[state=open]:text-muted-foreground',
        },
    },
    defaultVariants: {
        variant: 'default',
    },
});

export const DialogClose = ({
    className,
    variant,
    ...props
}: React.ComponentPropsWithoutRef<typeof DialogPrimitive.Close> &
    VariantProps<typeof dialogCloseVariants>) => (
    <DialogPrimitive.Close
        className={cn(dialogCloseVariants({ variant, className }))}
        {...props}
    >
        <X className="h-4 w-4" />
        <span className="sr-only">Close</span>
    </DialogPrimitive.Close>
);
